import React, { useState } from "react";
import { Form, Input, Button, Upload, Modal, Tooltip, Spin, Col } from "antd";
import { ArrowLeftOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { postRequest } from "../../api/http";
import userIcon from "../../assets/images/user-icon.svg";
import leftArrow from "../../assets/images/LeftArrow.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import "./addNewPartner.scss";
import { inputFieldCharLimit } from '../../config/index'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const AddPartnerForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [appLogoList, setAppLogoList] = useState([]);
  const [selectedAppLogo, setSelectedAppLogo] = useState(null);
  const [subdomainName, setSubdomainName] = useState("");
  // const [showInfoModal, setShowInfoModal] = useState(false);
  const [form] = Form.useForm();


  const onFinish = async (values) => {

    try {
      const token = sessionStorage.getItem("token");

      const formData = new FormData();

      if (fileList.length > 0) {
        formData.append("media", fileList[0].originFileObj);
      }

      if (appLogoList.length > 0) {
        formData.append("appLogo", appLogoList[0].originFileObj);
      }

      const inputObject = {
        name: values.name,
        email: values.email,
        siteName: values.siteName,
        addressInput: values.addressInput,
        mobileNumber: values.mobileNumber,
        // appName: values.appName,
        subDomainName: values.subdomainName,
      };

      formData.append(
        "input",
        new Blob([JSON.stringify(inputObject)], { type: "application/json" })
      );

      // --- Make API call ---
      const response = await fetch(userServiceApi.addPartner(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      console.log("response status:", response.status);

      // 🧩 Handle 401 before reading JSON (since json() might throw)
      if (response.status === 401) {
        toast.error("Session expired, please log in again.");
        sessionStorage.clear();
        navigate("/login");
        return;
      }

      // Parse JSON safely
      const data = await response.json();
      console.log("response data:", data);

      if (response.status === 200) {
        setLoading(true);
        toast.success("Partner added successfully");

        // Reset form fields
        form.resetFields();

        // Clear upload states
        setFileList([]);
        setSelectedFile(null);

        setAppLogoList([]);
        setSelectedAppLogo(null);

        setSubdomainName("");
        navigate("/admin");
      }
      else if (response.status === 400) {
        const match = data.message?.match(/\{"errors":\[.*\]\}/);
        if (match) {
          const parsed = JSON.parse(match[0]);
          if (parsed.errors && Array.isArray(parsed.errors) && parsed.errors.length > 0) {
            toast.error(parsed.errors[0].message);
          }
        } else if (data?.errorLog || data.error) {
          toast.error(data.message || data.error);
        } else {
          toast.error(data.message || "Invalid request. Please check your details and try again.");
        }
      } else {
        toast.error(data?.message || "Unexpected error occurred. Please try again.");
      }

    } catch (error) {
      console.error("Error caught in catch block:", error);
      toast.error(error.message || "Something went wrong, please try again.");
    } finally {
      setTimeout(() => {
        setLoading(false);

      }, 500)

    }
  };



  // const onFinish = async (values) => {
  //   try {
  //     // Retrieve the token from local storage
  //     const token = sessionStorage.getItem("token");

  //     // Create a FormData object to handle file uploads
  //     const formData = new FormData();

  //     // Create a Blob from the file content
  //     if (fileList.length > 0) {
  //       const fileBlob = new Blob([fileList[0].originFileObj], {
  //         type: fileList[0].type,
  //       });
  //       formData.append("media", fileBlob);
  //     } // assuming 'logo' is the name of the file field

  //     if (fileList.length > 0) {
  //       const fileBlob = new Blob([appLogoList[0].originFileObj], {
  //         type: appLogoList[0].type,
  //       });
  //       formData.append("appLogo", fileBlob);
  //     }

  //     // Create an 'input' part with nested data
  //     console.log("vals", values);
  //     const inputObject = {
  //       name: values.name,
  //       email: values.email,
  //       siteName: values.siteName,
  //       addressInput: values.addressInput,
  //       mobileNumber: values.mobileNumber,
  //       appName: values.appName,
  //       subDomainName: values.subdomainName,
  //     };

  //     // Append the 'input' part as a JSON string
  //     formData.append(
  //       "input",
  //       new Blob([JSON.stringify(inputObject)], { type: "application/json" })
  //     );

  //     // Include the token in the headers of the Axios request
  //     const headers = {
  //       Authorization: `Bearer ${token}`,
  //     };

  //     // Make the Axios request
  //     const response = await postRequest(
  //       userServiceApi.addPartner(),
  //       formData,
  //       {
  //         headers,
  //       }
  //     );

  //     const responseData = response.data;
  //     // console.log("API Response:", responseData);

  //     // Handle success response
  //     toast.success("Partner added successfully");
  //     navigate("/admin");
  //   } catch (error) {
  //     // console.error("API Error:", error);

  //     if (error.response) {
  //       // console.error("Server responded with status:", error.response.status);
  //       // console.error("Server response data:", error.response.data);
  //     } else if (error.request) {
  //       // console.error("No response received from the server");
  //     } else {
  //       // console.error("Error setting up the request:", error.message);
  //     }

  //     // console.error("Error adding partner");
  //   }
  // };

  const customRequest = ({ file, onSuccess }) => {
    const localUrl = URL.createObjectURL(file);

    setFileList([{ uid: file.uid, name: file.name }]);
    setSelectedFile(localUrl);

    // const avatar = document.getElementById("partner-avatar");
    // if (avatar) {
    //   avatar.src = localUrl;
    // }

    onSuccess();
  };

  const customAppLogoRequest = ({ file, onSuccess }) => {
    const localUrl = URL.createObjectURL(file);

    setAppLogoList([{ uid: file.uid, name: file.name }]);
    setSelectedAppLogo(localUrl);

    // const avatar = document.getElementById("partner-avatar");
    // if (avatar) {
    //   avatar.src = localUrl;
    // }

    onSuccess();
  };

  const checkIfImagePassed = (file, size)=>{
    if(!file?.type?.startsWith('image/')){
      toast.error('Only image files are allowed')
      return false
    }
    if (file && file.size >= size) {
      toast.error("File size should not exceed 2MB");
      return false
    }
    return true
  }

  const onFileChange = (info) => {
    setFileList(info.fileList.slice(-1));
  };

  const onAppLogoFileChange = (info) => {
    // console.log("info", info)
    setAppLogoList(info.fileList.slice(-1));
  };

  const handleSubdomainChange = (e) => {
    setSubdomainName(e.target.value);
  };

  // const numericValidator = (rule, value, callback) => {

  // const numericRegex = /^[0-9]+$/;

  // if (value && !numericRegex.test(value)) {
  //   callback('Please enter only numeric values.');
  // } else if (value && value.length > 10) {
  //   callback('Maximum length is 10 characters.');
  // } else {
  //   callback();
  // }

  // };

  const numericValidator = (_, value) => {
    // Check if the value contains more than 10 numeric characters
    if (value && value.replace(/\D/g, "").length > 10) {
      return Promise.reject("Please enter up to 10 numeric characters.");
    }
    return Promise.resolve();
  };

  return (
    <div className="add-partner-container">
      <div
        className="heading-backBtn"
        onClick={() => navigate("/admin")}
      >
        <img style={{ marginRight: "8px" }} src={leftArrow} alt="leftarrow" />
        Add new Partner
      </div>
      <div className="main-container">
        <div className="multipalFormStyle">
          {loading ? (
            <Spin
              className="data-loader loading-svg"
              tip="Loading"
              size="large"
            />
          ) : (
            <Form className="addPartner" onFinish={onFinish}>
              <div className="multipalFormRow">
                <div className="multipalFormCol">
                  <div className="formListRow">
                    <div className="formListCol">
                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Partner Name"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "Please input the partner name!",
                          },
                        ]}
                      >
                        <Input placeholder="Partner Name" maxLength={inputFieldCharLimit} />
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Email"
                        name="email"
                        normalize={(value) => value?.trim()}
                        rules={[
                          {
                            required: true,
                            message: "Please input the partner admin email!",
                          },
                          {
                            type: "email",
                            message: "Please enter a valid email address!",
                          },
                        ]}
                      >
                        <Input placeholder="Email" maxLength={inputFieldCharLimit} />
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Mobile Number"
                        name="mobileNumber"
                        rules={[
                          {
                            required: true,
                            message: "Please enter a mobile number!",
                          },
                        ]}
                      >
                        {/* <Input
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          placeholder="Mobile Number"
                          style={{ width: "100%" }}
                          maxLength={11}
                        /> */}

                        <PhoneInput
                          country={"in"}
                          enableSearch
                          inputStyle={{
                            width: "100%",
                            height: "40px"
                          }}
                          onChange={(value) => {
                            form.setFieldsValue({
                              mobileNumber: value,
                            });
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Site Name"
                        name="siteName"
                        rules={[
                          { required: true, message: "Please input the site name!" },
                        ]}
                      >
                        <Input maxLength={25} showCount placeholder="Site Name" />
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Address"
                        name={["addressInput", "street"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input the street address!",
                          },
                        ]}
                      >
                        <div className="helpInfo">
                          <Input placeholder="Address" />
                          <Tooltip
                            title={"Please enter your full address including street, city, state, and postal code for accurate records."}
                          >
                            <QuestionCircleOutlined className="question" />
                          </Tooltip>
                        </div>
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Logo"
                        name="logo"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e.fileList}
                        rules={[
                          {
                            required: true,
                            message: "Please upload the partner logo!",
                          },
                        ]}
                      >
                        <Upload
                          accept="image/*"
                          customRequest={customRequest}
                          beforeUpload={(file) => {
                            return checkIfImagePassed(file,2e6)
                          }}
                          fileList={fileList}
                          onChange={onFileChange}
                          showUploadList={false}
                        >
                          {/* <Avatar
              shape="circle"
              size={64}
              src={selectedFile || userIcon}
              style={{ marginRight: 10, width: 50, height: 50 }}
              id="partner-avatar"
            /> */}
                          {selectedFile ? (
                            <div>
                              <img
                                src={selectedFile}
                                style={{
                                  maxHeight: "120px",
                                  border: "1px solid #A5A5A5",
                                  borderRadius: "5px",
                                  objectFit: "contain",
                                  marginBottom: "-10px",
                                  marginRight: "10px",
                                }}
                              />
                              <Button
                                // style={{
                                //   backgroundColor: "green",
                                //   color: "white",
                                //   marginLeft: 10,
                                // }}
                                className="fileUploadBtn redBtn"
                              >
                                Upload Image
                              </Button>
                              <Tooltip
                                title={"Upload only .PNG, .JPG or .JPEG images and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels"}
                              >
                                <QuestionCircleOutlined className="question" />
                              </Tooltip>
                            </div>
                          ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={userIcon}
                                style={{ maxHeight: "60px", marginRight: "10px" }}
                              />
                              <Button
                                // style={{
                                //   backgroundColor: "green",
                                //   color: "white",
                                //   marginLeft: 10,
                                // }}
                                className="fileUploadBtn redBtn"
                              >
                                Upload Logo
                              </Button>
                              <Tooltip
                                title={"Upload only .PNG, .JPG or .JPEG images and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels"}
                              >
                                <QuestionCircleOutlined className="question" />
                              </Tooltip>
                            </div>
                          )}
                        </Upload>
                      </Form.Item>

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="Subdomain Name"
                        name="subdomainName"
                        rules={[
                          {
                            required: true,
                            message: "Please input the subdomain name!",
                          },
                        ]}
                      >
                        <Input
                          onChange={handleSubdomainChange}
                          placeholder="Subdomain"
                          maxLength={inputFieldCharLimit}
                        />
                      </Form.Item>

                      {subdomainName.length > 0 && (
                        <Form.Item
                          labelCol={{ span: 5 }}
                          className="subdomain-preview"
                          label=" "
                          name=""
                          colon={false}
                        >
                          <label
                            style={{ display: "block" }}
                          >{`Your end user URL would be ${subdomainName}.expo365.app and`}</label>
                          <label
                            style={{ display: "block" }}
                          >{`your organisation admin URL would be orgadmin.expo365.app/login/${subdomainName}`}</label>
                        </Form.Item>
                      )}

                      {/* <Form.Item
                        labelCol={{ span: 5 }}
                        label="App Name"
                        name="appName"
                        rules={[
                          { required: true, message: "Please input the app name!" },
                        ]}
                      >
                        <Input placeholder="App Name" maxLength={inputFieldCharLimit} />
                      </Form.Item> */}

                      <Form.Item
                        labelCol={{ span: 5 }}
                        label="App Logo"
                        name="appLogo"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e.fileList}
                        rules={[
                          { required: true, message: "Please upload the app logo!" },
                        ]}
                      >
                        <Upload
                          accept="image/*"
                          customRequest={customAppLogoRequest}
                          beforeUpload={(file) => {
                            return checkIfImagePassed(file,2e6)
                          }}
                          fileList={appLogoList}
                          onChange={onAppLogoFileChange}
                          showUploadList={false}
                        >
                          {selectedAppLogo ? (
                            <div>
                              <img
                                src={selectedAppLogo}
                                style={{
                                  maxHeight: "120px",
                                  border: "1px solid #A5A5A5",
                                  borderRadius: "5px",
                                  objectFit: "contain",
                                  marginBottom: "-10px",
                                  marginRight: "10px",
                                }}
                              />
                              <Button
                                // style={{
                                //   backgroundColor: "green",
                                //   color: "white",
                                //   marginLeft: 10,
                                // }}
                                className="fileUploadBtn redBtn"
                              >
                                Upload App Logo
                              </Button>
                              <Tooltip
                                title={`Upload only .PNG, .JPG or .JPEG and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels`}
                              >
                                <QuestionCircleOutlined className="question" />
                              </Tooltip>
                            </div>
                          ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <img
                                src={userIcon}
                                style={{ maxHeight: "60px", marginRight: "10px" }}
                              />
                              <Button
                                // style={{
                                //   backgroundColor: "green",
                                //   color: "white",
                                //   marginLeft: 10,
                                // }}
                                className="fileUploadBtn redBtn"
                              >
                                Upload App Logo
                              </Button>
                              <Tooltip
                                title={`Upload only .PNG, .JPG or .JPEG and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels`}
                              >
                                <QuestionCircleOutlined className="question" />
                              </Tooltip>
                            </div>
                          )}
                        </Upload>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="formListRow">
                    <div className="formListCol" style={{ textAlign: 'right' }}>
                      <Form.Item>
                        <Button className="sendBtn redBtn" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </div>

      </div>
      {/* <Modal
        open={showInfoModal}
        onOk={() => setShowInfoModal(false)}
        onCancel={() => setShowInfoModal(false)}
        footer={null}
      >
        <h2>App logo info modal</h2>
      </Modal> */}
    </div>
  );
};

export default AddPartnerForm;
